/* ============================================================
   WowSticker — Mega menu "Prodotti"
   Injects the desktop dropdown panel into .nav-mega and wires
   hover / focus / click / Esc / outside-click open & close.
   Fonte dati: WOW_MEGA (collezione scelta nell'header) →
   WowCatalog.PRODUCTS (catalogo Shopify) → fallback statico.
   Le voci "Per utilizzo"/"Formati speciali" puntano solo a
   prodotti realmente presenti a catalogo.
   ============================================================ */
(function(){
  var wrap = document.querySelector('.nav-mega');
  if(!wrap) return;

  /* Base per gli asset: nel tema Shopify la imposta header.liquid (WOW_ASSET_BASE),
     nelle pagine HTML del prototipo è la cartella locale assets/. */
  var AB = window.WOW_ASSET_BASE || '';

  var CAT = window.WowCatalog || null;
  var HAS_SHOP = !!(CAT && CAT.SHOP && CAT.PRODUCTS && CAT.PRODUCTS.length);

  // URL reale del prodotto per una chiave materiale; null se non a catalogo.
  function keyUrl(key, fallbackHref){
    if(HAS_SHOP){
      var known = CAT.PRODUCTS.some(function(p){ return p.key === key; });
      return known ? CAT.urlFor(key) : null;
    }
    return fallbackHref;
  }

  var MATERIALI;
  if(window.WOW_MEGA && window.WOW_MEGA.materials && window.WOW_MEGA.materials.length){
    MATERIALI = window.WOW_MEGA.materials.map(function(m){
      return { img: m.img || (AB+'wowsticker-logo.png'), t: m.t, d: m.d || '', href: m.href };
    });
  } else if(HAS_SHOP){
    MATERIALI = CAT.PRODUCTS.slice(0, 8).map(function(p){
      return { img: p.img || (AB+'wowsticker-logo.png'), t: p.label, d: p.use || '', href: p.url };
    });
  } else {
    MATERIALI = [
      { img:AB+'prod-vinile-classico.jpg', t:'Vinile classico',   d:'Colori pieni e brillanti',            href:'/products/vinile' },
      { img:AB+'prod-trasparente.jpg',     t:'Trasparente',       d:'Perfetto per vetri e superfici lisce', href:'/products/trasparente' },
      { img:AB+'prod-olografico.jpg',      t:'Olografico',        d:'Effetto iridescente unico',           href:'/products/olografico' },
      { img:AB+'prod-oro.jpg',             t:'Oro',               d:'Finitura metallizzata premium',       href:'/products/oro' },
      { img:AB+'prod-magnetico.jpg',       t:'Magnetico',         d:'Perfetti per frigo e metallo',        href:'/products/magnetico' },
      { img:AB+'prod-dtf.jpg',             t:'Termoadesivo (DTF)',d:'Ideali per tessuti e abbigliamento',  href:'/products/dtf' }
    ];
  }

  var USI = [
    { ic:'inventory_2',    t:'Packaging',     d:'Etichette per prodotti e confezioni', key:'etichette',   href:'/products/etichette' },
    { ic:'storefront',     t:'Vetrine',       d:'Adesivi per vetri e negozi',          key:'trasparente', href:'/products/trasparente' },
    { ic:'checkroom',      t:'Abbigliamento', d:'Stampe e adesivi per tessuti',        key:'dtf',         href:'/products/dtf' },
    { ic:'directions_car', t:'Veicoli',       d:'Auto, moto e furgoni',                key:'vinile',      href:'/products/vinile' },
    { ic:'celebration',    t:'Eventi',        d:'Promo, fiere e manifestazioni',       key:'olografico',  href:'/collections/all#speciali' },
    { ic:'wallpaper',      t:'Pareti',        d:'Decorazioni murali e rimovibili',     key:'parete',      href:'/products/parete' }
  ];
  var FORMATI = [
    { ic:'grid_view',    t:'Sticker in foglio', d:'Più adesivi sullo stesso foglio',       key:'foglio',       href:'/products/sticker-in-foglio' },
    { ic:'content_cut',  t:'Prespaziati',       d:'Scritte pronte da applicare',           key:'prespaziato',  href:'/products/prespaziato' },
    { ic:'layers',       t:'Mezzo taglio',      d:'Facili da staccare',                    key:'mezzotaglio',  href:'/products/mezzotaglio' },
    { ic:'crop_free',    t:'Maxi adesivi',      d:'Grandi formati per massima visibilità', key:'maxi',         href:'/products/maxi' },
    { ic:'footprint',    t:'Calpestabili',      d:'Antiscivolo e resistenti',              key:'calpestabile', href:'/products/calpestabile' },
    { ic:'format_paint', t:'Da parete',         d:'Wall sticker rimovibili',               key:'parete',       href:'/products/parete' }
  ];
  function resolve(list){
    var out = [];
    list.forEach(function(o){
      var href = keyUrl(o.key, o.href);
      if(href) out.push({ ic:o.ic, t:o.t, d:o.d, href:href });
    });
    return out;
  }
  USI = resolve(USI);
  FORMATI = resolve(FORMATI);

  var isHome = /(^|\/)(Home\.html)?$/i.test(location.pathname.split('/').pop() || '');
  var assistantHref = isHome ? '#wow-assistant' : '/#wow-assistant';

  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function itemImg(o){
    return '<a class="mega-item" href="'+o.href+'">'
      + '<span class="mega-ic"><img src="'+o.img+'" alt="" loading="lazy"></span>'
      + '<span class="mega-txt"><b>'+esc(o.t)+'</b><small>'+esc(o.d)+'</small></span></a>';
  }
  function itemIc(o){
    return '<a class="mega-item" href="'+o.href+'">'
      + '<span class="mega-ic"><span class="msr">'+o.ic+'</span></span>'
      + '<span class="mega-txt"><b>'+esc(o.t)+'</b><small>'+esc(o.d)+'</small></span></a>';
  }
  function col(title, icon, rows, render){
    if(!rows.length) return '';
    return '<div class="mega-col"><div class="mega-col-title"><span class="msr">'+icon+'</span>'+title+'</div>'
      + rows.map(render).join('') + '</div>';
  }
  /* Colonne configurate nel theme editor: window.WOW_MEGA.cols = [{title, icon,
     display:'image'|'icon', items:[{t,d,href,img,ic}], allLabel, allHref}] */
  function colFromSetting(c){
    var rows = c.items || [];
    if(!rows.length) return '';
    var render = c.display === 'icon' ? itemIc : itemImg;
    var html = '<div class="mega-col"><div class="mega-col-title">'
      + (c.icon ? '<span class="msr">'+esc(c.icon)+'</span>' : '') + esc(c.title||'') + '</div>'
      + rows.map(function(o){
          return render({ t:o.t, d:o.d||'', href:o.href,
            img: o.img || (AB+'wowsticker-logo.png'),
            ic: o.ic || c.icon || 'label' });
        }).join('');
    if(c.allLabel) html += '<a class="mega-all" href="'+(c.allHref||'#')+'">'+esc(c.allLabel)+' →</a>';
    return html + '</div>';
  }
  function cardHtml(){
    var c = (window.WOW_MEGA && window.WOW_MEGA.card) || null;
    if(c && !c.title) return '';
    var title = (c && c.title) || 'Non sai quale scegliere?';
    var text  = (c && c.text)  || 'Rispondi a 3 domande e ti consigliamo <span class="hl">il prodotto perfetto</span> per te.';
    var btn   = (c && c.btnLabel) || 'Trova il mio sticker';
    var href  = (c && c.btnHref) || assistantHref;
    var note  = c && c.note !== undefined ? c.note : 'Ci vogliono 30 secondi';
    var img   = (c && c.img) || (AB+'wow.svg');
    return '<div class="mega-card">'
      + (img ? '<div class="mega-card-art"><img src="'+img+'" alt=""></div>' : '')
      + '<h4>'+esc(title)+'</h4>'
      + '<p>'+text+'</p>'
      + (btn ? '<a class="btn btn-primary btn-sm" href="'+href+'">'+esc(btn)+' <span class="ic">→</span></a>' : '')
      + (note ? '<span class="mega-note"><span class="msr">schedule</span> '+esc(note)+'</span>' : '')
      + '</div>';
  }

  var cfgCols = (window.WOW_MEGA && window.WOW_MEGA.cols) || null;
  var colsHtml = (cfgCols && cfgCols.length)
    ? cfgCols.map(colFromSetting).join('')
    : col('Per materiale','palette', MATERIALI, itemImg)
      + col('Per utilizzo','category', USI, itemIc)
      + col('Formati speciali','auto_awesome', FORMATI, itemIc);

  var panel = document.createElement('div');
  panel.className = 'mega';
  panel.setAttribute('role','menu');
  panel.innerHTML = colsHtml + cardHtml();
  wrap.appendChild(panel);

  var trigger = wrap.querySelector('.nav-mega-trigger');
  var openT = null, closeT = null;

  function open(){
    clearTimeout(closeT);
    wrap.classList.add('open');
    if(trigger) trigger.setAttribute('aria-expanded','true');
  }
  function close(){
    wrap.classList.remove('open');
    if(trigger) trigger.setAttribute('aria-expanded','false');
  }
  function openDelayed(){ clearTimeout(closeT); openT = setTimeout(open, 60); }
  function closeDelayed(){ clearTimeout(openT); closeT = setTimeout(close, 160); }

  // Hover (desktop)
  wrap.addEventListener('mouseenter', openDelayed);
  wrap.addEventListener('mouseleave', closeDelayed);

  // Keyboard focus opens; blur out closes
  wrap.addEventListener('focusin', open);
  wrap.addEventListener('focusout', function(e){
    if(!wrap.contains(e.relatedTarget)) close();
  });

  // Click on the trigger toggles instead of navigating (only where the
  // dropdown is actually shown — i.e. pointer devices / desktop widths)
  if(trigger){
    trigger.addEventListener('click', function(e){
      if(window.matchMedia('(max-width:1180px)').matches) return; // let it navigate on mobile
      // If already open, allow navigation on a second click
      if(!wrap.classList.contains('open')){
        e.preventDefault();
        open();
      }
    });
  }

  // Esc closes
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
  // Outside click closes
  document.addEventListener('click', function(e){ if(!wrap.contains(e.target)) close(); });
})();

/* ============================================================
   Footer link columns → collapsible accordions on mobile (≤600px)
   ============================================================ */
(function(){
  var cols = Array.prototype.slice.call(document.querySelectorAll('.footer .foot-col'));
  if(!cols.length) return;
  var mq = window.matchMedia('(max-width:600px)');

  function toggle(){
    var col = this.closest('.foot-col');
    if(col) col.classList.toggle('is-open');
  }
  function enable(col){
    if(col.hasAttribute('data-acc')) return;
    var h = col.querySelector('h4');
    if(!h) return;
    col.setAttribute('data-acc','');
    col.classList.remove('is-open');            // collapsed by default
    h.setAttribute('role','button');
    h.setAttribute('tabindex','0');
    h.setAttribute('aria-expanded','false');
    h.addEventListener('click', toggle);
    h.addEventListener('keydown', function(e){
      if(e.key==='Enter' || e.key===' '){ e.preventDefault(); toggle.call(h); }
    });
    // keep aria in sync
    new MutationObserver(function(){ h.setAttribute('aria-expanded', col.classList.contains('is-open')?'true':'false'); })
      .observe(col, { attributes:true, attributeFilter:['class'] });
  }
  function disable(col){
    col.removeAttribute('data-acc');
    col.classList.remove('is-open');
  }
  function apply(){
    cols.forEach(mq.matches ? enable : disable);
  }
  apply();
  if(mq.addEventListener) mq.addEventListener('change', apply);
  else if(mq.addListener) mq.addListener(apply);
})();
